import type { CareersContent } from "../types/CarrerContent";

export const careersContent: CareersContent = {
  sectionLabel: "Careers at Hungerford",
  title: "Real Projects. Real Growth. Real Ownership.",
  subtitle: "Built for Civil Engineers in Heavy Civil Construction",
  email: "daniel@hungerfordconsulting.com",
  whatMakesHungerfordDifferent: {
    heading: "What Makes Hungerford Different",
    features: [
      {
        icon: "HammerIcon",
        title: "Built for Civil Engineers",
        text: "We focus on heavy civil: sitework, earthwork, utilities, and concrete, the kind of projects that shape infrastructure.",
      },
      {
        icon: "TrendingUpIcon",
        title: "Fast Career Acceleration",
        text: "Move up based on performance, not seniority. Reach meaningful responsibility in months, not years.",
      },
      {
        icon: "BriefcaseIcon",
        title: "Real Project Ownership",
        text: "Take on full scopes from $750K to $4M, not just a small piece of someone else's plan.",
      },
      {
        icon: "DollarSignIcon",
        title: "Performance-Based Pay",
        text: "Earn up to six figures within 18 months. Your compensation reflects your results.",
      },
      {
        icon: "HomeIcon",
        title: "Remote-First, High Autonomy",
        text: "Work from home with structure, support, and freedom, no trailers, no commuting.",
      },
      {
        icon: "TargetIcon",
        title: "Structured Coaching",
        text: "Tight coaching loops, clear leveling, and direct feedback, not vague mentorship.",
      },
      {
        icon: "GlobeIcon",
        title: "National Exposure",
        text: "We estimate projects across the U.S. and build a resume that opens doors anywhere.",
      },
      {
        icon: "LayersIcon",
        title: "A Platform to Build From",
        text: "Grow into leadership, training, or design while helping build and improve our systems.",
      },
    ],
  },
  HowWeCompare: {
    heading: "How We Compare",
    text: "See how Hungerford stacks up against traditional career paths for civil engineers.",
    table: {
      labels: [
        "Career Path",
        "Responsibility",
        "Ownership",
        "Compensation",
        "Growth Speed",
        "Environment",
        "Training",
        "Impact",
        "Exit Options",
      ],
      columns: [
        {
          label: "Civil Contractors",
          values: [
            "Linear (EIT → PM)",
            "Admin, RFIs, support",
            "Follow PM or Super",
            "$55–85K/year",
            "Slow unless fast-tracked",
            "Long hours, hierarchy",
            "Light mentoring",
            "Small part of big build",
            "Switch firms or PM",
          ],
        },
        {
          label: "Consulting Firms",
          values: [
            "EIT to Sr. Eng",
            "Redlines, reports",
            "Follow senior spec",
            "$60–90K + OT",
            "Gradual",
            "Office, billable",
            "Project-dependent",
            "Narrow deliverables",
            "Grad school or lateral",
          ],
        },
        {
          label: "Government Roles",
          values: [
            "Tenure-based",
            "Permits, inspections",
            "Execute policy",
            "$50–95K fixed",
            "Grid-based",
            "Stable, low-stress",
            "Standard onboarding",
            "Minor process tweaks",
            "Consulting or private firm",
          ],
        },
        {
          label: "Hungerford",
          values: [
            "6 mo. to lead small bids, 2 yrs to lead teams",
            "$750K–$4M jobs from Day 1",
            "Complete ownership of your projects",
            "$7.5–10K/mo in 60 days",
            "Based entirely on performance",
            "Remote, fast, autonomous",
            "Structured, coaching, regular feddback",
            "Help build the next generation of the platform",
            "Run a pod, lead area, or build new systems ",
          ],
        },
      ],
    },
  },
  readyToApply: {
    heading: "Ready to Apply?",
    intro:
      "We’re hiring a select team of 30 estimators before December, all civil engineers, all focused on heavy civil.",
    requirements: [
      {
        icon: "EngineeringIcon",
        text: "A civil engineering grad with 2 – 5 years of experience",
      },
      {
        icon: "GpsFixedIcon",
        text: "Based in the GTA",
      },
      {
        icon: "TrendingUpIcon",
        text: "Sharp, coachable, and ready to grow",
      },
    ],
    highlightBox: {
      title: "Apply before December to be part of this exclusive cohort.",
      description:
        "You’ll get full training, real responsibility, and national project experience fast.",
    },
    ctaLabel: "Apply Now",
    email: "daniel@hungerfordconsulting.com",
  },
  workAtHungerford: {
    heading: "Why Work at Hungerford?",
    content: `Hungerford is not a traditional project management firm, it’s a purpose built platform designed to accelerate the careers of civil engineers by placing them directly into real heavy civil work, from day one.

As part of our team, you’ll immediately take ownership of meaningful infrastructure projects, ranging from $750K to $4M in scope without the red tape, with full support along the way.`,
  },

  careerPath: {
    title: "What we offer at Hungerford:",
    description:
      "At Hungerford, your career progression is based on performance, not seniority. Here's what we offer and how you can advance with us. \n\n**We offer:**\n\n- **Daily feedback** and **structured coaching**.\n- A **clear progression path**, mapped from day one.\n- A system built for **performance, not politics**.",
    timeline: [
      {
        label: "6 Months",
        title: "",
        description:
          "Within your first 6 months, you'll be building and managing full estimates.",
      },
      {
        label: "2 Years",
        title: "",
        description:
          "Within 2 years, you’ll be helping refine our workflows and training others.",
      },
      {
        label: "3 Years",
        title: "",
        description:
          "Within 3 years, you will be leading a region, owning a vertical, or building a new system entirely.",
      },
    ],
    closingRemark: {
      bold: "The best part?",
      text: "Hungerford is built to give you control, over your time, your growth, and your future. \nThis isn’t just a job. It’s a launchpad. And we’re looking for engineers who are ready to build",
    },
  },
};
